import { useEffect, useState } from 'react';
import {fetchBrands} from '@/services/api'

export const useBrands = () => {
  const [brands,setBrands] = useState([])
  const [selectedBrand,setSelectedBrand] = useState();
  const [error,setError] = useState()
  const [loading,setLoading] = useState(false)

  const handleBrandSelect= (brand)=>{
    setSelectedBrand(brand)
  }
  const clearBrandSelection = ()=>{
    setSelectedBrand(null);
  }

  useEffect(() => {
    const loadBrands = async () => {
      console.log("Fetching Brands")
      try {
        setLoading(true);
        const data = await fetchBrands();
        setBrands(data.brands);
      } catch (err) {
        setError('Failed to load regions');
      } finally {
        setLoading(false);
      }
    };
    loadBrands();
  }, []);

  return {
    brands,
    selectedBrand,
    loading,
    error,
    handleBrandSelect,
    clearBrandSelection
  };
};